// import React from "react";
// import { Bar } from "react-chartjs-2";
// import { useSelector } from "react-redux";
// import "../BudgetDetailReports.css";
// export const ReportChart = () => {
//   const budgetReport = useSelector(
//     (state) => state.rootReducer.loginUser.budgetReportData
//   );
//   // for chart data we have to give it transaction data as argument

//   function transformData(data) {
//     const result = [];

//     function getMonthYear(date) {
//       const options = { year: "numeric", month: "long" };
//       return new Date(date).toLocaleDateString(undefined, options);
//     }

//     const groupedData = {};
//     data.forEach((item) => {
//       const monthYear = getMonthYear(item.date);
//       if (!groupedData[monthYear]) {
//         groupedData[monthYear] = {};
//       }
//       const key = item.categoryFromPlaid || "Unknown";
//       if (!groupedData[monthYear][key]) {
//         groupedData[monthYear][key] = 0;
//       }
//       groupedData[monthYear][key] += item.amount;
//     });

//     Object.keys(groupedData).forEach((month, index) => {
//       const labels = Object.keys(groupedData[month]);
//       const data = labels.map((label) => groupedData[month][label].toFixed(2));
//       result.push({
//         id: index + 1,
//         title: `${month} - Detailed Budget`,
//         labels,
//         data,
//       });
//     });

//     return result;
//   }

//   const chartsData = transformData(budgetReport && budgetReport);
//   console.log("chartsData", chartsData, budgetReport);
//   const chartOptions = {
//     legend: {
//       display: false,
//     },

//     maintainAspectRatio: false,
//     responsive: true,
//     scales: {
//       xAxes: [
//         {
//           gridLines: {
//             color: "rgba(0, 0, 0, 0)",
//           },
//         },
//       ],
//       yAxes: [
//         {
//           ticks: {
//             callback: function (value) {
//               return new Intl.NumberFormat("en-US", {
//                 style: "currency",
//                 currency: "USD",
//                 minimumFractionDigits: 0,
//                 maximumFractionDigits: 0,
//               }).format(value);
//             },
//           },
//           //   gridLines: {
//           //     color: "rgba(0, 0, 0, 0)",
//           //   },
//         },
//       ],
//     },
//   };

//   const charts = [
//     {
//       id: 1,
//       title: "Dec 2023 - Detailed Budget",
//       labels: ["Shopping", "Traveling", "Saving"],
//       data: ["400", "600", "1000"],
//     },
//     {
//       id: 2,
//       title: "Nov 2023 - Detailed Budget",
//       labels: ["Bank Fee", "Medical", "Education"],
//       data: ["1400", "700", "1200"],
//     },
//     {
//       id: 3,
//       title: "Oct 2023 - Detailed Budget",
//       labels: ["Food and Drink", "Traveling", "Saving"],
//       data: ["900", "1200", "600"],
//     },
//   ];
//   return (
//     <div className="BudgetReportMain1">
//       {chartsData &&
//         chartsData.map((item, index) => {
//           const data = item.data;
//           return (
//             <div key={index} className="reportChartsSection">
//               <div className="reportCardTitle">{item.title}</div>
//               <div className="chartView">
//                 <Bar
//                   data={{
//                     labels: item.labels,
//                     datasets: [
//                       {
//                         label: "Category",
//                         data: data,
//                         fill: false,
//                         backgroundColor: "#2A3DA3",
//                         borderColor: "#2A3DA3",
//                       },
//                     ],
//                   }}
//                   height={300}
//                   options={chartOptions}
//                 />
//               </div>
//             </div>
//           );
//         })}
//     </div>
//   );
// };

import React from "react";
import { Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import "../BudgetDetailReports.css";
import "../../MainDashboard/mainDashboard.css";
export const ReportChart = () => {
  const budgetReport = useSelector(
    (state) => state.rootReducer.loginUser.budgetReportData
  );
  // for chart data we have to give it transaction data as argument

  function transformData(data) {
    const result = [];

    function getMonthYear(date) {
      const options = { year: "numeric", month: "long" };
      return new Date(date).toLocaleDateString(undefined, options);
    }

    const groupedData = {};
    data.forEach((item) => {
      const monthYear = getMonthYear(item.date);
      if (!groupedData[monthYear]) {
        groupedData[monthYear] = {};
      }
      const key = item.categoryFromPlaid || "Unknown";
      if (!groupedData[monthYear][key]) {
        groupedData[monthYear][key] = 0;
      }
      groupedData[monthYear][key] += item.amount;
    });

    Object.keys(groupedData).forEach((month, index) => {
      const labels = Object.keys(groupedData[month]);
      const data = labels.map((label) => groupedData[month][label].toFixed(2));
      result.push({
        id: index + 1,
        title: `${month} - Detailed Budget`,
        labels,
        data,
      });
    });

    return result;
  }

  const chartsData = transformData(budgetReport && budgetReport);
  console.log("chartsData", chartsData, budgetReport);
  const chartOptions = {
    legend: {
      display: false,
    },

    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(value);
            },
          },
          //   gridLines: {
          //     color: "rgba(0, 0, 0, 0)",
          //   },
        },
      ],
    },
  };

  const charts = [
    {
      id: 1,
      title: "Dec 2023 - Detailed Budget",
      labels: ["Shopping", "Traveling", "Saving"],
      data: ["400", "600", "1000"],
    },
    {
      id: 2,
      title: "Nov 2023 - Detailed Budget",
      labels: ["Bank Fee", "Medical", "Education"],
      data: ["1400", "700", "1200"],
    },
    {
      id: 3,
      title: "Oct 2023 - Detailed Budget",
      labels: ["Food and Drink", "Traveling", "Saving"],
      data: ["900", "1200", "600"],
    },
  ];
  return (
    <div className="BudgetReportMain1">
      {chartsData &&
        chartsData.map((item, index) => {
          const data = item.data;
          return (
            <div key={index} className="reportChartsSection">
              <div className="reportCardTitle">{item.title}</div>
              <div className="chartView">
                <Bar
                  data={{
                    labels: item.labels,
                    datasets: [
                      {
                        label: "Category",
                        data: data,
                        fill: false,
                        backgroundColor: "#2A3DA3",
                        borderColor: "#2A3DA3",
                      },
                    ],
                  }}
                  height={300}
                  options={chartOptions}
                />
              </div>
            </div>
          );
        })}
    </div>
  );
};
